import { ReactNode } from 'react';

/**
 * 아코디언 카드 한 칸을 화면에서 제어하기 위한 props.
 * 저장을 영역이 스스로 처리하는 경우(비밀번호, 클래스 코드)에 쓴다.
 */
export type AccordionControlProps = {
  isOpen: boolean;
  onToggle: () => void;
  isEditing: boolean;
  /** 다른 영역을 수정하는 중이면 이 영역은 수정을 시작할 수 없다. */
  disabled: boolean;
  onEdit: () => void;
  /** 수정 종료 (저장 완료 / 취소) */
  onClose: () => void;
};

/**
 * 아코디언 카드의 본문. 펼침 상태에 따라 높이가 바뀐다.
 * grid-rows 0fr/1fr 은 내용 높이를 몰라도 애니메이션이 되는 방식이다.
 * (접기가 없는 화면은 이 컴포넌트 없이 본문을 그대로 둔다)
 *
 * 제목 줄은 `SectionHeader` 에 `isOpen`/`onToggle` 을 넘겨서 만든다.
 */
export const AccordionPanel = ({
  isOpen,
  children,
}: {
  isOpen: boolean;
  children: ReactNode;
}) => {
  return (
    <div
      className={`grid transition-[grid-template-rows] duration-200 ease-out ${
        isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
      }`}
      aria-hidden={!isOpen}
    >
      <div className="overflow-hidden">{children}</div>
    </div>
  );
};

export default AccordionPanel;
